import { DataBean } from "../DataBean";

export class CustomerType extends DataBean {

    public async getCustomerTypeCatalog(priorityType: number): Promise<any> {
        return this.getCustomService(
            "QuickTurnService",
            "java.util.List_getCustomerTypeCatalog_Number",
            [priorityType]);
    }

}
